@if (componentToRender) {
  <ng-container *ngComponentOutlet="componentToRender; injector: componentInjector" />
}
